import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { DischargeTmpl } from '../../../interfaces/masters/discharge-tmpl';
import { HttpService } from './http.service';

//import { HttpService } from '../../../../../@core/backend/common/api/http.service';

//import { DischargeTmpl } from '../../interface/master/discharge-tmpl';

@Injectable()
export class DischargeTmplApi {
  private readonly apiController: string = 'discharge-tmpl';

  constructor(private api: HttpService) { }

  list(url: string, options?: any): Observable<any[]> {
    const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
    
    return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
  }

  getById(url : string, options?: any): Observable<DischargeTmpl> {
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directGet(url,header);
  }

  add(url:string, data: DischargeTmpl):Observable<DischargeTmpl[]>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    
    return this.api.post( url, data, header);
  }
  saveCertificate(url: string, data: any): Observable<any> {

  const headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept': 'application/vnd.ezovion.hateoas+json'
  });

  return this.api.post(url, data, { headers });
}

  update(url:string, data: DischargeTmpl):Observable<any>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    // const formData: FormData = new FormData();
    // formData.append('Image', data.photo);
    // data.photo = formData;
    return this.api.directPut( url, data, {headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
  }

  delete(url: string):Observable<any>{
    return this.api.directDelete(url);
  }
}
